export const GA_MEASUREMENT_ID = "G-7C516RZZFJ";
export const CONSENT_STORAGE_KEY = "mardatiq.analyticsConsent";
export const COOKIE_SETTINGS_EVENT = "mardatiq:cookie-settings";

let scriptPromise = null;
let initialized = false;

function ensureGtag() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  return window.gtag;
}

export function setDefaultConsent() {
  if (typeof window === "undefined") return;
  const gtag = ensureGtag();
  gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });
}

export function getAnalyticsConsent() {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(CONSENT_STORAGE_KEY);
  return value === "granted" || value === "denied" ? value : null;
}

export function loadAnalytics() {
  if (typeof window === "undefined") return Promise.resolve(false);
  const gtag = ensureGtag();
  gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  if (!initialized) {
    gtag("js", new Date());
    gtag("config", GA_MEASUREMENT_ID, { send_page_view: false, anonymize_ip: true });
    initialized = true;
  }

  if (document.querySelector(`script[data-mardatiq-ga4="${GA_MEASUREMENT_ID}"]`)) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.mardatiqGa4 = GA_MEASUREMENT_ID;
    script.onload = () => resolve(true);
    script.onerror = () => { scriptPromise = null; reject(new Error("Unable to load Google Analytics")); };
    document.head.appendChild(script);
  });
  return scriptPromise;
}

function deleteGaCookies() {
  if (typeof document === "undefined") return;
  document.cookie.split(";").forEach((entry) => {
    const name = entry.split("=")[0].trim();
    if (!name.startsWith("_ga")) return;
    const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax";
    document.cookie = `${name}=; ${expires}`;
    document.cookie = `${name}=; ${expires}; domain=.mardatiq.com`;
  });
}

export function grantAnalyticsConsent() {
  window.localStorage.setItem(CONSENT_STORAGE_KEY, "granted");
  return loadAnalytics();
}

export function denyAnalyticsConsent() {
  window.localStorage.setItem(CONSENT_STORAGE_KEY, "denied");
  const gtag = ensureGtag();
  gtag("consent", "update", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  deleteGaCookies();
}

export function trackPageView(path) {
  if (getAnalyticsConsent() !== "granted" || !initialized || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: path,
  });
}

export function openCookieSettings() {
  if (typeof window !== "undefined") window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}

setDefaultConsent();
